module.exports = __webpack_public_path__ + "static/app-shot-1-4-1266fea976b96db8851881051c703a5c.jpg";